module.exports = __webpack_public_path__ + "img/waist.709d6c73.png";